module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/flower-2-4106cd221be719f7f15b9662f810e846.svg";